/**
 * Accordion block. See `patterns/accordion.php`.
 *
 * When a visitor opens an item, scroll the item into view.
 * With auto-close on, an item above can close and move the opened item
 * up and out of view. A long panel can also go below the window.
 *
 * `block: "nearest"` scrolls the shortest distance. It does not scroll when
 * the item is fully visible. When the item is taller than the window, the
 * heading goes to the top.
 * The root `scroll-padding-top` keeps the heading below the sticky header.
 * The root `scroll-behavior` is smooth only when the visitor allows motion.
 * Keyboard focus stays on the button.
 */
document.addEventListener("click", (event) => {
  const toggle = event.target.closest?.(".wp-block-accordion-heading__toggle");
  if (!toggle) return;

  // The core script updates the item in a microtask after this event.
  // A timeout runs after all microtasks.
  setTimeout(() => {
    if (toggle.getAttribute("aria-expanded") !== "true") return;

    toggle.closest(".wp-block-accordion-item")?.scrollIntoView({ block: "nearest" });
  });
});
